import useAppState, { IAppState } from './useAppState';

function tokenSelector(state: IAppState): string {
  return state.token;
}
export function useAuthToken(): string {
  return useAppState(tokenSelector);
}
